module.exports = __webpack_public_path__ + "static/loeb-b416d821d0e87ffd89b5ede28737a8fd.png";